import { render, staticRenderFns } from "./SettlementBreakdown.vue?vue&type=template&id=746bf255&"
import script from "./SettlementBreakdown.vue?vue&type=script&lang=js&"
export * from "./SettlementBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./SettlementBreakdown.vue?vue&type=style&index=0&id=746bf255&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports